var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpeechbubble = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 209 146"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C0D9CA",
  d: "M27.525 14.56C-4.277 35.644-8.608 80.954 14.983 102.485c20.153 18.391 53.751 22.88 81.522 21.534s65.843 2.691 68.083 21.981c15.229-14.804 31.802-39.925 35.385-46.654l.116-.217c3.746-7.027 16.751-31.428 2.124-54.511C187.432 21.29 153.39 9.178 130.098 4.69 106.807.205 59.327-6.524 27.525 14.561"
})));
export default SvgSpeechbubble;